import { combineReducers } from '@reduxjs/toolkit';

import authReducer from './auth';
import plansReducer from './plans';
import homeReducer from './home';
import ordersTabsReducer from './orders';

const rootReducers = combineReducers({
  auth: authReducer,
  plans: plansReducer,
  home: homeReducer,
  orders: ordersTabsReducer,
});

export default rootReducers;
